import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: '0.5rem 1rem',

    '& section': {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      fontWeight: 'bold',
      gap: '2rem',

      '& div': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      },
    },
  },

  flag: {
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    display: "inline-block",
    width: "1.5rem",
    height: "1.5rem",
    marginRight: "0.3rem",
  },

  flagBelgium: {
    backgroundImage: 'url(img/homepage/flags/be.svg)',
  },

  flagSwitzerland: {
    backgroundImage: 'url(img/homepage/flags/ch.svg)',
  },

  flagGermany: {
    backgroundImage: 'url(img/homepage/flags/de.svg)',
  },

  flagIreland: {
    backgroundImage: 'url(img/homepage/flags/ie.svg)',
  },

  flagIndia: {
    backgroundImage: 'url(img/homepage/flags/in.svg)',
  },
}));
